import { PaperClipOutlined } from '@ant-design/icons'
import { GraviButton } from '@gravitate-js/excalibrr'
import { type ButtonProps, Tooltip } from 'antd'

type AttachmentsButtonProps = {
  onClick: ButtonProps['onClick']
  numAttachments: number
  tooltipMessage: string
  disabled: boolean
}

export function AttachmentsButton({ onClick, numAttachments, tooltipMessage, disabled }: AttachmentsButtonProps) {
  return (
    <div className='vertical-flex-center pr-3 pl-3'>
      <Tooltip title={tooltipMessage} mouseEnterDelay={0.5} placement='top'>
        <GraviButton shape='default' icon={<PaperClipOutlined />} onClick={onClick} disabled={disabled}>
          Attachments ({numAttachments})
        </GraviButton>
      </Tooltip>
    </div>
  )
}
